import {Injectable} from '@angular/core';

import $ from 'jquery';
import {every, get, set, some, trim} from 'lodash-es';

import {AccessControlService} from '@wms/services';
import {findValueOf, isEmptObject} from "@wms/core";

@Injectable({
  providedIn: 'root'
})
export class PreferenceService {

  public preferences: any = {};

  constructor(private accessControlService: AccessControlService) { }

  load(projectDetails: any) {
    return Promise.all([
      this.accessControlService.getWorkspacePermissions(),
      this.accessControlService.getProjectPermissions(projectDetails.id),
      this.accessControlService.getPermissionsByProjectType(projectDetails.type.toLowerCase(), projectDetails.platformType.toLowerCase()),
      this.accessControlService.getDefaultPermissions()
    ]).then(preferencesArr => {
      let preferences = {};
      preferencesArr.reduce(function (merged, _preferences) {
        return $.extend(true, merged, _preferences);
      }, preferences);

      //fail safe. May have to extend this further.
      set(preferences, 'project.enterprise.artifacts', {});
      
      // // Disable grid and linear layout only for Prism projects
      // if (projectDetails.template === 'PRISM') {
      //   if (projectDetails.platformType === "WEB") {
      //     set(preferences, 'components.layouts.structure.layoutGrid', false);
      //   } else if (projectDetails.platformType === "MOBILE" || projectDetails.platformType === "NATIVE_MOBILE") {
      //     set(preferences, 'components.layouts.structure.layoutGrid', false);
      //     set(preferences, 'components.layouts.structure.linearFlexLayout', false);
      //   }
      // }

      if(projectDetails.template != 'PRISM' && projectDetails.platformType === "WEB"){
          set(preferences, 'components.widgets.formWidgets.iconButtonToggleable', false);
      }
      this.preferences = preferences;
    });
  }


  hasAccess(feature: any) {
    if (!feature) {
      return true;
    }
    var hasOR = feature.indexOf('||') !== -1,
      hasAND = feature.indexOf('&&') !== -1,
      hasNOT = feature.indexOf('!') !== -1,
      conditions;

    if (hasOR) {
      conditions = feature.split('||');
    } else if (hasAND) {
      conditions = feature.split('&&');
    } else {
      conditions = [feature];
    }
    conditions = conditions.map(trim);

    if (hasOR) {
      return some(conditions.map(this.has(conditions)));
    }

    if (hasAND) {
      return every(conditions.map(this.has(conditions)));
    }

    if (hasNOT) {
      return !this.has(conditions[0].substring(1))
    }

    return this.has(conditions[0]);

  }
  has(condition: any) {
    var val = findValueOf(this.preferences, condition);
    return !!(isEmptObject(val) || val);
  }

  get(path?: any) {
    if (!path) {
      return this.preferences;
    } else {
      return get(this.preferences, path);
    }
  }
}
